/* unplugin-vue-components disabled */import script from "./DepartmentTreeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DepartmentTreeModal.vue?vue&type=script&setup=true&lang=js"

import "./DepartmentTreeModal.vue?vue&type=style&index=0&id=7552358e&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7552358e"]])

export default __exports__